<div
  *ngIf="flightStatusFacade.spinner; else loaded"
  class="flex flex-col items-center gap-16 p-16"
>
  <div class="component-loader"></div>
  <span class="text-body-sm text-body-copy text-center ml-8">
    {{ loaderContent.label }}
  </span>
</div>

<ng-template #loaded>
  <div
    *ngIf="
      flightStatusFacade.flightStatusContent$ | async as flightStatusContent;
      else errorTemplate
    "
    class="relative"
  >
    <idp-flight-status
      (openModalEmit)="openModal($event)"
      [selectedAirport]="
        destinationType === 'From' ? originAirport : destinationAirport
      "
      [destinationType]="destinationType"
      [isSelected]="isSelected"
      (retrieveFlightStatus)="retrieveFlightStatus($event)"
      (analyticsEvent)="handleAnalytics($event)"
      (airportSwapped)="swapAirportValues()"
      [content]="flightStatusContent"
      [predictiveCities]="flightStatusFacade.predictiveCities"
    ></idp-flight-status>
    <idp-airport-dropdown
      *ngIf="flightStatusContent && isSelected"
      [openModal]="openModalEvent"
      [selectedValue]="
        destinationType === 'From' ? originAirport : destinationAirport
      "
      [searchErrorMessage]="
        flightStatusFacade.airportSearchErrorService.searchErrorMessage
      "
      [airportModalContent]="airportModalContent"
      (airportSelected)="onAirportSelected($event)"
      (searchValueEmit)="searchForAirport($event)"
      (closeModal)="openModal({ isOpen: false })"
    ></idp-airport-dropdown>
  </div>
</ng-template>

<ng-template #errorTemplate>
  <div
    [ngClass]="{
      hidden: !showAlert
    }"
    class="flex flex-col gap-8"
  >
    <section
      [id]="flightStatusFacade.adapter.messageBannerId"
      class="message-banner"
    ></section>
  </div>
</ng-template>
